var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 132.29 132.29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 113.77,
    cy: 66.146,
    r: 12.107
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(76.893)",
    cx: 124.99,
    cy: -63.263,
    r: 12.107
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(211.11)",
    cx: -91.727,
    cy: -70.078,
    r: 12.107
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-72)",
    cx: -57.185,
    cy: 38.055,
    r: 12.107
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(4.8934)",
    cx: 44.303,
    cy: 21.199,
    r: 12.107
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(139.11)",
    cx: -51.7,
    cy: -77.715,
    r: 12.107
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m110.06 79.695a0.245 0.245 0 0 0-0.0918 0.013672 0.245 0.245 0 0 0-0.14453 0.31445s0.31931 0.86077 0.39648 2.457c0.07718 1.5963-0.09568 3.9086-1.1016 6.7637-1.0067 2.8574-2.2174 4.606-3.168 5.6387-0.95055 1.0326-1.6152 1.3379-1.6152 1.3379a0.245 0.245 0 0 0-0.11914 0.32617 0.245 0.245 0 0 0 0.32617 0.11914s0.77256-0.36812 1.7695-1.4512c0.99697-1.0831 2.2427-2.8921 3.2695-5.8066 1.0277-2.9169 1.2069-5.297 1.127-6.9512-0.07997-1.6542-0.42578-2.6016-0.42578-2.6016a0.245 0.245 0 0 0-0.22265-0.16016z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    shapeRendering: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m102.39 97.401 2.2418-3.2114 1.6599 3.5512z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.68 93.668-2.7617 3.9551 0.45117 0.039062 4.3535 0.37891-2.043-4.373zm-0.09179 1.043 1.2773 2.7305-3-0.26172 1.7227-2.4688z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m76.43 112.08a0.245 0.245 0 0 0-0.1582 0.07032s-0.65041 0.64538-2.0723 1.375c-1.4219 0.72961-3.5996 1.5298-6.6152 1.793-3.0181 0.26342-5.1123-0.11749-6.4453-0.55664-1.333-0.43916-1.8848-0.91797-1.8848-0.91797a0.245 0.245 0 0 0-0.3457 0.02539 0.245 0.245 0 0 0 0.025391 0.3457s0.6546 0.55307 2.0527 1.0137 3.5603 0.84682 6.6387 0.57813c3.0809-0.26892 5.3234-1.0877 6.7969-1.8438s2.1934-1.4629 2.1934-1.4629a0.245 0.245 0 0 0 0.001954-0.34766 0.245 0.245 0 0 0-0.1875-0.07227z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    shapeRendering: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m57.375 112.56 3.8507 0.71519-2.5485 2.9785z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.979 112.22 0.15039 0.42578 1.4531 4.1211 3.1367-3.666-4.7402-0.88086zm0.79297 0.67773 2.9609 0.55274-1.959 2.2891-1.002-2.8418z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m20.721 83.488a0.245 0.245 0 0 0-0.23828 0.20703s-0.12317 0.84696 0.22461 2.2773c0.34778 1.4304 1.1627 3.4718 3.0176 5.9434 1.8564 2.4735 3.7358 3.9435 5.1562 4.7949 1.4205 0.85137 2.4023 1.0879 2.4023 1.0879a0.245 0.245 0 0 0 0.29492-0.17969 0.245 0.245 0 0 0-0.18164-0.29688s-0.8929-0.20968-2.2637-1.0312c-1.3708-0.82157-3.1986-2.2488-5.0156-4.6699-1.8185-2.4231-2.602-4.3999-2.9336-5.7637s-0.2168-2.0879-0.2168-2.0879a0.245 0.245 0 0 0-0.20508-0.2793 0.245 0.245 0 0 0-0.041016-0.001953z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    shapeRendering: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.065 81.496 1.4276 3.6471-3.8754-0.58968z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.145 80.98-0.2832 0.35352-2.7305 3.4102 4.7715 0.72656-1.7578-4.4902zm-0.1582 1.0332 1.0977 2.8027-2.9785-0.45312 1.8809-2.3496z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m28.18 35.744a0.245 0.245 0 0 0-0.091797 0.019531s-0.78872 0.33068-1.834 1.3672c-1.0453 1.0365-2.3708 2.7876-3.5293 5.6523-1.1595 2.8671-1.4479 5.2365-1.4434 6.8926s0.30664 2.6191 0.30664 2.6191a0.245 0.245 0 0 0 0.30859 0.16016 0.245 0.245 0 0 0 0.1582-0.30859s-0.27882-0.87258-0.2832-2.4707 0.27136-3.9027 1.4062-6.709c1.1358-2.8086 2.4253-4.5 3.4219-5.4883 0.99661-0.98826 1.6758-1.2617 1.6758-1.2617a0.245 0.245 0 0 0 0.13281-0.32031 0.245 0.245 0 0 0-0.22852-0.15234z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    shapeRendering: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.273 35.126-2.3858 3.106-1.4964-3.6231z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.977 34.291 1.8418 4.459 2.9375-3.8223-0.44922-0.060546-4.3301-0.57617zm0.82813 0.63672 2.9863 0.39648-1.8359 2.3887-1.1504-2.7852z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m64.812 16.389c-3.0922 0.051264-5.3852 0.7109-6.9082 1.3613-1.523 0.65043-2.291 1.3047-2.291 1.3047a0.245 0.245 0 0 0-0.027343 0.34375 0.245 0.245 0 0 0 0.3457 0.027343s0.69436-0.5989 2.1641-1.2266c1.4697-0.62767 3.6979-1.2721 6.7246-1.3223 3.0292-0.050219 5.0899 0.47782 6.3887 1.0098 1.2988 0.53195 1.8164 1.0488 1.8164 1.0488a0.245 0.245 0 0 0 0.34766-0.001953 0.245 0.245 0 0 0-0.001953-0.3457s-0.61434-0.59638-1.9766-1.1543c-1.3622-0.55792-3.4923-1.0961-6.582-1.0449z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    shapeRendering: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m74.809 20.35-3.7907-0.98461 2.7519-2.7916z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.902 16.068-3.3887 3.4355 4.668 1.2129-0.12109-0.43555-1.1582-4.2129zm-0.26367 1.0137 0.79883 2.9023-2.9141-0.75781 2.1152-2.1445z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m102.28 33.734a0.245 0.245 0 0 0-0.23828 0.15234 0.245 0.245 0 0 0 0.13476 0.32031s0.85181 0.34166 2.084 1.3594c1.2322 1.0177 2.8261 2.7031 4.2598 5.3691 1.4349 2.6683 1.9136 4.7406 2.0371 6.1387s-0.09961 2.0957-0.09961 2.0957a0.245 0.245 0 0 0 0.16016 0.30664 0.245 0.245 0 0 0 0.30664-0.16016s0.25059-0.81881 0.12109-2.2852c-0.12949-1.4663-0.63022-3.6065-2.0938-6.3281-1.4647-2.7238-3.104-4.459-4.3809-5.5137s-2.209-1.4375-2.209-1.4375a0.245 0.245 0 0 0-0.08203-0.017578z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    shapeRendering: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m110.02 51.403-0.86493-3.8198 3.7432 1.1638z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.8 47.199 1.0644 4.7031 0.33399-0.30664 3.2109-2.9648-4.6094-1.4316zm0.70898 0.76758 2.8809 0.89453-2.2148 2.043-0.66602-2.9375z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/process.d2f001c3.svg";
export { ForwardRef as ReactComponent };